'use strict';
'use es6';

/* These getters are for use while we transition from `PubNubMessageRecord` messages to `CommonMessage` messages.
  They support both PubNubMessageRecord messages and CommonMessage messages.
  If you find yourself debugging something involving these data structures, consider that there may be a mixture of `CommonMessage` and `PubNubMessageRecord`.
  Dont assume that all `common-message-format` operators are compatible with `PubNubMessageRecord` either, since this is an incomplete list.
  */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuickReplyReplies = exports.getQuickReplyAllowUserInput = exports.getQuickReplyAllowMultiSelect = exports.getQuickReply = exports.getQuickReplyAttachment = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _cmfComparators = require('./cmfComparators');

var _pubnubMessageGetters = require('../../pubnub-message/operators/pubnubMessageGetters');

var PubNubMessageGetters = _interopRequireWildcard(_pubnubMessageGetters);

var _quickReplyAttachmentGetters = require('./quickReplyAttachmentGetters');

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _attachmentTypes = require('../constants/attachmentTypes');

var _getAttachments = require('./getAttachments');

var _isInitialMessage = require('../../initial-message/operators/isInitialMessage');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getQuickReplyAttachment = exports.getQuickReplyAttachment = function getQuickReplyAttachment(commonMessage) {
  var attachments = (0, _getAttachments.getAttachments)(commonMessage);

  if (!attachments) {
    return undefined;
  }

  var quickReplyAttachment = attachments.find(function (attachmentObject) {
    return (0, _get2.default)(_messageTypes.MESSAGE_TYPE_ID, attachmentObject) === _attachmentTypes.QUICK_REPLIES;
  });

  return quickReplyAttachment;
};

var getQuickReply = exports.getQuickReply = function getQuickReply(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message) || (0, _isInitialMessage.isInitialMessage)(message)) {
    return getQuickReplyAttachment(message);
  }

  return PubNubMessageGetters.getQuickReply(message);
};

var getQuickReplyAllowMultiSelect = exports.getQuickReplyAllowMultiSelect = function getQuickReplyAllowMultiSelect(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message) || (0, _isInitialMessage.isInitialMessage)(message)) {
    var quickReplyAttachment = getQuickReplyAttachment(message);
    return (0, _quickReplyAttachmentGetters.getAllowMultiSelect)(quickReplyAttachment);
  }

  return PubNubMessageGetters.getAllowMultiSelect(message);
};

var getQuickReplyAllowUserInput = exports.getQuickReplyAllowUserInput = function getQuickReplyAllowUserInput(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message) || (0, _isInitialMessage.isInitialMessage)(message)) {
    var quickReplyAttachment = getQuickReplyAttachment(message);
    return (0, _quickReplyAttachmentGetters.getAllowUserInput)(quickReplyAttachment);
  }

  return PubNubMessageGetters.getAllowUserInput(message);
};

var getQuickReplyReplies = exports.getQuickReplyReplies = function getQuickReplyReplies(message) {
  if ((0, _cmfComparators.isCommonMessageFormat)(message) || (0, _isInitialMessage.isInitialMessage)(message)) {
    var quickReplyAttachment = getQuickReplyAttachment(message);
    return (0, _quickReplyAttachmentGetters.getQuickReplies)(quickReplyAttachment);
  }

  return PubNubMessageGetters.getQuickReplies(message);
};